"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferredPricing = void 0;
var PreferredPricing;
(function (PreferredPricing) {
    PreferredPricing["Origin"] = "origin";
    PreferredPricing["Destination"] = "destination";
    PreferredPricing["Cheaper"] = "cheaper";
})(PreferredPricing || (exports.PreferredPricing = PreferredPricing = {}));
//# sourceMappingURL=PreferredPricing.js.map